import { useLayoutEffect, useState } from "react";
import { MAX_MOBILE_VIEW_WIDTH } from "utils/dimens";

/**
 * This custom hook
 * @returns {windowHeight, windowWidth}
 * which are all OBSERVABLE.
 *
 * These values are being updated as the size of the browser changes.
 * @see {window.addEventListener}
 */

const useWindowResizeListener = () => {
  const [windowWidth, setWindowWidth] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const setWindowWidthAndHeight = () => {
    const { innerHeight, innerWidth } = window;

    setWindowHeight(innerHeight);
    setWindowWidth(innerWidth);
    setIsMobile(innerWidth <= MAX_MOBILE_VIEW_WIDTH);
  };

  const observeWindowSize = () => {
    setWindowWidthAndHeight();

    window.addEventListener("resize", setWindowWidthAndHeight);

    //kill the listener once the component that consumes this hook unmounts
    return () => {
      window.removeEventListener("resize", setWindowWidthAndHeight);
    };
  };

  useLayoutEffect(observeWindowSize, []);

  return {
    windowWidth,
    windowHeight,
    isMobile,
  };
};

export default useWindowResizeListener;
